export enum ErrorTypes {
  GENERAL_ERROR = 1,
  TTL_ERROR = 2,
  ORDER_CREATED_ERROR = 3,
}

export enum OrderConfigStatus {
  CREATED = 'CREATED',
  PROCESSED = 'PROCESSED',
}
